import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import {ja} from "vuejs-datepicker/dist/locale"
import Datepicker from 'vuejs-datepicker'
import moment from "moment"
import ApiManager from '@/utils/ApiManager'

export default {
  name: 'Location',
  components: {
    Loading,
    Datepicker
  },
  metaInfo() {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({title: title})
    return this.getMeta
  },
  data() {
    return {
      loading: false,
      makeCodeLoading: false,

      // 検索
      inpService: '',
      inpDeviceSerial: '',

      // スマホ連携管理
      inpIsExpiryNotEnabled: false,
      basicLocationInfo: {},
      basicLocationEmptyInfo: '',

      // date picker option
      expirationDateOptions: {
        ja: ja,
        typeable: true,
        disabledDates: {
          to: moment().startOf('day').toDate(),
          from: moment().add(90, 'day').startOf('day').toDate()
        }
      },
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.clear()
    this.resetState()
  },
  computed: {
    ...mapState({
      categoryName: state => state.location.categoryName,
      // model
      locationModel: state => state.location.locationModel,
      serviceModel: state => state.location.serviceModel,
      serviceInfoModel: state => state.location.serviceInfoModel,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      isAdmin: 'auth/isAdmin',
      isOperator: 'auth/isOperator',
      userServiceUuid: 'auth/userServiceUuid',
      getValue: 'location/getValue',
      getStatus: 'location/getStatus',
      isDeviceSpLinkCodeIssued: 'location/isDeviceSpLinkCodeIssued'
    }),

    // list
    serviceList() {
      return this.serviceModel
        .filter(item => item.serviceStatus === 1)
        .map(item => {
          return {
            value: item.serviceUuid,
            label: item.serviceName
          }
        })
    },
    selectedService() {
      return this.inpService !== ''
    },
    validateAddOrUpdBtn() {
      if (!this.inpIsExpiryNotEnabled)
        return !this.basicLocationInfo.expirationDate
      return false
    }
  },
  watch: {
    confirmAccepted: function (to) {
      // 登録
      if (this.confirmKey === 'storeDeviceSpLinkCode') {
        if (to) this.storeDeviceSpLinkCode()
      }
      // 更新
      if (this.confirmKey === 'updateDeviceSpLinkCode') {
        if (to) this.updateDeviceSpLinkCode()
      }
      // 
      if (this.confirmKey === 'releaseDeviceSpLinkCode') {
        if (to) this.releaseDeviceSpLinkCode()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'location/loadModel',
      loadLocationList: 'location/loadLocationList',
      resetState: 'location/resetState',
    }),
    ...mapMutations({
      setInputValue: 'location/setInputValue'
    }),

    init() {
      this.loading = true

      // データ検索パラメータ
      let serviceParams = {}
      if (this.isOperator) {
        serviceParams.serviceUuid = this.userServiceUuid
      }
      // データ読出し
      this.loadModel({
        serviceParams: serviceParams,
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          if (this.isOperator) {
            this.inpService = this.userServiceUuid
          }
        })
        .catch(error => {
          this.loading = false
          this.showError(error || null)
        })
    },
    // クリア
    clear() {
      this.inpDeviceSerial = ''
      this.inpIsExpiryNotEnabled = false
      this.basicLocationInfo = {}
    },
    search() {
      this.loading = true
      // データ検索パラメータ
      let locationParams = {
        serviceUuid: this.isAdmin ? this.inpService : this.userServiceUuid
      }
      if (this.inpDeviceSerial)
        locationParams.deviceSerial = this.inpDeviceSerial
      // データ読出し
      this.loadLocationList({
        locationParams: locationParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.basicLocationInfo = $.extend(true, {}, this.locationModel)
          this.basicLocationEmptyInfo = ''
          this.inpIsExpiryNotEnabled = !this.locationModel.isExpiryEnabled
          this.loading = false
          this.makeCodeLoading = false
        })
        .catch(error => {
          this.basicLocationInfo = {}
          this.basicLocationEmptyInfo = '検索条件に一致するロケーションはありません'
          this.loading = false
          this.makeCodeLoading = false
        })
    },
    changeExpirationDate(value) {
      if (value === null) {
        this.basicLocationInfo.expirationDate = ''
      } else {
        let dateObj = new Date(value)
        const date = new Date(dateObj.setHours(0, 0, 0, 1))
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        this.basicLocationInfo.expirationDate = `${yyyy}-${mm}-${dd}`;
      }
    },
    storeConfirm() {
      this.showConfirm({
        key: 'storeDeviceSpLinkCode',
        title: 'スマホ連携',
        body: '連携コードを登録します。よろしいですか？',
        acceptLabel: '登録'
      });
    },
    updateConfirm() {
      this.showConfirm({
        key: 'updateDeviceSpLinkCode',
        title: 'スマホ連携',
        body: '連携コードを更新します。よろしいですか？',
        acceptLabel: '更新'
      });
    },
    releaseConfirm() {
      this.showConfirm({
        key: 'releaseDeviceSpLinkCode',
        title: 'スマホ連携',
        body: 'このロケーションのスマホ連携を解除しますか？',
        acceptLabel: '解除'
      });
    },
    makeDeviceSpLinkCode() {
      this.makeCodeLoading = true;
      ApiManager.request(
        ['location'],
        ['v1LocationSpLinkageAuthCode'],
        [{}])
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            this.showToast({
              title: '連携コード',
              body: '連携コードを取得しました。'
            })
            this.basicLocationInfo.deviceSpLinkCode = res[0].data.authCode
          } else if (status.error) {
            this.makeCodeLoading = false
            // エラーメッセージ表示
            this.showError(res)
          } else {
            this.makeCodeLoading = false
            // アプリケーションエラー表示
            this.showError(null)
          }
        })
        // eslint-disable-next-line
        .catch(error => {
          this.makeCodeLoading = false
          this.showError(error)
        })
    },
    storeDeviceSpLinkCode() {
      this.loading = true
      // 登録
      let parameters = {
        deviceSerial: this.inpDeviceSerial,
        isExpiryEnabled: !this.inpIsExpiryNotEnabled,
        deviceSpLinkCode: this.basicLocationInfo.deviceSpLinkCode,
      }
      if (this.basicLocationInfo.expirationDate)
        parameters.expirationDate = this.basicLocationInfo.expirationDate
      ApiManager.request(
        ['location'],
        ['v1LocationSpLinkageStore'],
        [parameters])
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            this.showToast({
              title: '連携コード',
              body: '連携コードを登録しました。'
            })
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          this.search()
        })
        // eslint-disable-next-line
        .catch(error => {
          this.loading = false
          this.makeCodeLoading = false
          this.showError(error)
        })
    },
    updateDeviceSpLinkCode() {
      this.loading = true
      // 更新
      let parameters = {
        deviceSpLinkCodeUuid: this.basicLocationInfo.deviceSpLinkCodeUuid,
        isExpiryEnabled: !this.inpIsExpiryNotEnabled,
        deviceSpLinkCode: this.basicLocationInfo.deviceSpLinkCode,
      }
      if (this.basicLocationInfo.expirationDate)
        parameters.expirationDate = this.basicLocationInfo.expirationDate
      ApiManager.request(
        ['location'],
        ['v1LocationSpLinkageUpdate'],
        [parameters])
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            this.showToast({
              title: '連携コード',
              body: '連携コードを更新しました。'
            })
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          this.search()
        })
        // eslint-disable-next-line
        .catch(error => {
          this.loading = false
          this.makeCodeLoading = false
          this.showError(error)
        })
    },
    releaseDeviceSpLinkCode() {
      this.loading = true;
      // 連携解除
      let parameters = {
        releaseType: 1,
        serviceUuid: this.isAdmin ? this.inpService : this.userServiceUuid,
        deviceSerial: this.inpDeviceSerial
      };
      ApiManager.request(
        ["serviceFunction"],
        ["v1ServiceSpRelease"],
        [parameters]
      )
        .then(res => {
          let status = Utility.parseResponse(res)
          if (status.result) {
            this.modelName = ""
            // toast
            this.showToast({
              title: "スマホ連携",
              body: this.inpDeviceSerial + "に紐づいた連携スマホアプリを一括解除しました。"
            });
          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          this.search()
        })
        .catch(error => {
          this.loading = false
          this.makeCodeLoading = false
          this.showError(error)
        })
    },
  }
}